@if (!isProcessing()) {
  <ng-content></ng-content>
} @else {
  <sky-ui-spinner size="s" color="primary"></sky-ui-spinner>
}
